












import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import Company from "@/models/company/Company";
import {enumTextFromValue} from "@/helpers/functions_asi";
import {CompanyType, Permissions} from "@/helpers/constants";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import CompanyUpdateDialogBasicData from "@/components/company/CompanyUpdateDialogBasicData.vue";

@Component({
	components: {CompanyUpdateDialogBasicData, AsiCardDetailEntry, AsiCardDetail}
})
export default class CompanyCardBasicData extends Vue {

	@Prop({type: Object, default: null})
	public company!: Company | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get type(): string | null {
		return enumTextFromValue(CompanyType, this.company?.type ?? null, true);
	}

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	@Emit('companyChanged')
	public companyChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
